export default __webpack_public_path__ + "static/media/blank-image.c5a28847.jpg";